import React from 'react';
import Header from './HeaderComponent';
import { Fade, Stagger } from 'react-animation-components';
import { Card } from 'reactstrap';

function About(props){
    var renderDevelopers = props.developers.map((developer)=>{
        return(
            <Fade in key={developer.id}>
                <Card className="mt-3 p1 p-2">
                    <div className="row">
                        <div className="col-4 col-md-2">
                            <img src={developer.image} alt={developer.name} className="img-fluid img-thumbnail"/>
                        </div>
                        <div className="col-8 col-md-10">
                            <div className="row">
                                <div className="col-12"><h5>{developer.name}</h5></div>
                            </div>
                            <div className="row">
                                <div className="col-12"><h6>Roll No.: {developer.roll_no}</h6></div>
                            </div>
                            <div className="row">
                                <div className="col-12"><h6>Email: <a href={"mailto:".concat(developer.email)}>{developer.email}</a></h6></div>
                            </div>
                            <div className="row">
                                <div className="col-12"><p><b>Skills:</b> {developer.skills}</p></div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Fade>
        );
    });
    return(
        <>
            <Header destination="About the Developers"/>
            <div className="container">
                <div className="row mt-3">
                    <div className="col-12">
                        <h3>Developers</h3>
                    </div>
                </div>
                <Stagger in>
                    {renderDevelopers}
                    <Fade in>
                        <div className="row mt-3">
                            <div className="col-12">
                                <h3>Supervisor</h3>
                            </div>
                        </div>
                    </Fade>
                    <Fade in>
                        <Card className="mt-3 mb-3 p1 p-2">
                            <div className="row">
                                <div className="col-4 col-md-2">
                                    <img src="/assets/images/manjit-singh.jpg" alt="Manjit Singh" className="img-fluid img-thumbnail"/>
                                </div>
                                <div className="col-8 col-md-10">
                                    <div className="row">
                                        <div className="col-12"><h5>Er. Manjit Singh</h5></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12"><h6>Head of Department, Computer Science and Engineering</h6></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12"><h6>Ambala College of Engineering and Applied Research</h6></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12"><h6>Email: <a href="mailto:hodcseace@ambalacollege.com">hodcseace@ambalacollege.com</a></h6></div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Fade>
                </Stagger>
            </div>
        </>
    );
}

export default About;